"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.embedProps = embedProps;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function embedProps(elements, extraProps) {
  return _react.default.Children.map(elements, element => /*#__PURE__*/_react.default.cloneElement(element, extraProps));
}